import Background from "./background-static-bluegreen.jpg";
import Flex from "app/components/UI/Flex";
import PropTypes from "prop-types";
import React from "react";
import classes from "./StaticPage.module.css";
import classnames from "classnames";

export const StaticPage = ({ children, className, ...props }) => (
  <Flex direction="row" center className={classes.pageContainer}>
    <Flex direction="row" middle center className={classes.staticPage}>
      <img className={classes.staticPage__background} src={Background} alt="" />
      <div className={classnames(classes.staticPage__content, className)} {...props}>
        {children}
      </div>
    </Flex>
  </Flex>
);

StaticPage.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

export default StaticPage;



// WEBPACK FOOTER //
// ./src/app/components/UI/StaticPage/StaticPage.js